import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity, CommunityRequest, CommunityRequestType } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { ExplorerProvider } from '../providers/explorer-provider';
import { CommunityRequestLayout, CommunityRequestsAsideLayout, ExplorerEntityDetailsLayout, useView } from '@shapeable/ui';
import { useCommunityRequestTypes } from '../../hooks/use-community-request-types';
const cls = classNames('radar-home-layout');

// -------- Types -------->

export type ExplorerConversationsLayoutProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const ExplorerConversationsLayoutDefaultProps: Omit<ExplorerConversationsLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
    background: ${theme.COLOR('bright')};
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    .shp--explorer-entity-details-layout__banner-and-tabs {
      display: none;
    }
  `,
  desktop: css`
    
  `,
});

const ConversationsStyles = breakpoints({
  base: css`
  `,
});

const ConversationsAsideStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,

  CommunityRequests: styled(CommunityRequestLayout)`${ConversationsStyles}`,
  CommunityRequestsAside: styled(CommunityRequestsAsideLayout)`${ConversationsAsideStyles}`,
};

export const ExplorerConversationsLayout: Shapeable.FC<ExplorerConversationsLayoutProps> = (props) => {
  const { className, children, entity } = props;
  
  const { activeSubView } = useView('conversations');
  const communityRequestTypes = useCommunityRequestTypes() as CommunityRequestType[];

  const activeRequestType = communityRequestTypes.find((type) => type.id === activeSubView);

  return (
    <ExplorerProvider>
        <My.Container className={cls.name(className)}>
          <My.Layout
            asideMaxWidth={400}
            asideHeaderProps={{ navigationProps: { showIcon: false }}}
            entity={entity}
            isAsideSticky={false}
            asideIsRevealed={false}
            showSiteFooter={() => false}
            content={
              <My.CommunityRequests
                activeEntity={activeRequestType}
              />
            }
            metaHead={
              <My.CommunityRequestsAside 
                items={communityRequestTypes} 
                mainView='conversations'
                // asideLabel='Filter By Bulletin Types:'
                intro={{
                  text: 'Through these Bulletin Boards you can reach out to the global ConnectOre network. Post a request or an offer, and tag it by type to make it easier to follow up on. You can @mention people, organisations and Value Chain themes.',
                }}
              />
            }
          />
          {children}
        </My.Container>
    </ExplorerProvider>
  )
};

ExplorerConversationsLayout.defaultProps = ExplorerConversationsLayoutDefaultProps;
ExplorerConversationsLayout.cls = cls;